import React from 'react';

import Link from '../../../Typography/Link/Link';
import Icon from '../../../Icon2/Icon';
import Button from '../../../Button/Button';

declare const window: Window & typeof globalThis & {
  Commandbar: {
    isLoaded: boolean | undefined;
  },
  CommandBar: {
    openHelpHub: (articleId: { articleId: any }) => void;
  }
}

const LearnMore = ({ linkText, className, link, target, mixPanelEvent, fontWeight, fontSize, iconName, withIcon, underLine, underLineType, moduleName, event, fontColor, helpIcon, information, testId, iconVersion, iconSize, openHelpCenter, linkId, userAnalytics }: any): any => {
  const openHelpDoc = (linkId) => {
    window?.Commandbar?.isLoaded && window?.CommandBar?.openHelpHub({ articleId: linkId });
  }
  const handleMixPanelEvent = (): any => {
    if (mixPanelEvent && event && moduleName) {
      const eventName = event
      const eventMetadata = {
        module_name: moduleName,
        learn_more_URL: link,
        mixpanel: true
      }
      userAnalytics.trackEvent(eventName, eventMetadata)
    }
  };

  if (helpIcon) {
    return (
      <span onClick={handleMixPanelEvent} aria-hidden>
        <a href={link} target={target} aria-label='Navigate to the docs' className="LearnMore__icon" data-test-id={testId} tabIndex={-1}>
          <Button version="v2" buttonType="tertiary" icon="v2-Help" size="medium" onlyIcon={true} onlyIconHoverColor="secondary" className="learmore-help-icon-button" />
        </a>
      </span>
    );
  }
  if (information) {
    return (
      <span onClick={handleMixPanelEvent} aria-hidden>
        <a href={link} target={target} aria-label='Navigate to the docs' data-test-id={testId}>
          <Icon icon="Information" version="v2" size="medium" />
        </a>
      </span>
    );
  }
  if (withIcon) {
    return (
      <span onClick={handleMixPanelEvent} aria-hidden>
        <Link testId={testId} href={link} className={className} target={target} fontColor={fontColor} fontSize={fontSize} underLineType={underLineType} fontWeight={fontWeight} type={"external"} underline={underLine} iconName={iconName} iconProps={{ version: iconVersion, size: iconSize }}>
          {linkText}
        </Link>
      </span>
    );
  }
  if (openHelpCenter) {
    return (
      <span onClick={handleMixPanelEvent} aria-hidden>
        <Button version="v2" onClick={() => { openHelpDoc(linkId) }} buttonType="link" icon="v2-Help" iconAlignment="right" size="medium" onlyIcon={false} onlyIconHoverColor="secondary" className="learmore-help-icon-button" > {linkText} </Button>
      </span>
    )
  }
  return (
    <span onClick={handleMixPanelEvent} aria-hidden>
      <Link testId={testId} href={link} className={className} target={target} fontColor={fontColor} fontSize={fontSize} underline={underLine} underLineType={underLineType} fontWeight={fontWeight} >
        {linkText}
      </Link>
    </span>
  );
}

export default LearnMore;

LearnMore.defaultProps = {
  testId: 'cs-learn-more-link'
}